import { BUTTON_SIZES } from 'ui/button';
import { AreaChart, BarChart, ColumnChart, LineChart, NumberChart, SplineChart } from 'ui/icons';
import noop from 'utils/noop';
import { IconButton } from './Visualization.styled';

// type Props = {
//   /** The icon name to display. */
//   icon: string,
//   /** Name of the visualization. */
//   name: string,
//   /** Callback function when the visualization is clicked. */
//   onClick: (string) => void,
//   /** If visualization is currently selected. */
//   selected: boolean,
//   disabled: boolean,
// };

const CHART_MAP = {
  AreaChart: AreaChart,
  BarChart: BarChart,
  LineChart: LineChart,
  ColumnChart: ColumnChart,
  NumberChart: NumberChart,
  SplineChart: SplineChart,
};

const Visualization = ({ name, icon, onClick = noop, selected, disabled, ...otherProps }) => {
  /** Gets the displayed Icon for visualization. Defaults to line. */
  const DisplayedIcon = CHART_MAP[icon] || LineChart;
  const handleClick = (e) => onClick(e, name);

  return (
    <IconButton
      data-test="dashboard-visualization"
      data-type={icon}
      disabled={disabled}
      size={BUTTON_SIZES.LARGE}
      onClick={disabled ? noop : handleClick}
      data-icon-selected={selected || undefined}
      data-icon-hover
      {...otherProps}
    >
      <DisplayedIcon
        height={64}
        width={64}
        disabled={disabled}
        data-icon-selected={selected || undefined}
        data-icon-hover
        isColorInherited
      />
    </IconButton>
  );
};

export default Visualization;
